import { type RouteConfig } from 'vue-router'

export const AttendeeRouter: RouteConfig[] = [
  {
    path: '/attendees',
    component: async () => import('./AttendeeList.vue'),
  },
]
